// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.navbar-container-PdBzT {
  width: 64px;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  border-right: 1px solid var(--border-color);
  background-color: white;
  z-index: 3;
  padding: 12px 0px;
}

.navbar-content-lSlNK {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
}
`, "",{"version":3,"sources":["webpack://./../core/src/components/navbar/navbar.module.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,8BAA8B;EAC9B,2CAA2C;EAC3C,uBAAuB;EACvB,UAAU;EACV,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;AACX","sourcesContent":[".container {\n  width: 64px;\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  border-right: 1px solid var(--border-color);\n  background-color: white;\n  z-index: 3;\n  padding: 12px 0px;\n}\n\n.content {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 12px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `navbar-container-PdBzT`,
	"content": `navbar-content-lSlNK`
};
export default ___CSS_LOADER_EXPORT___;
